import { customElement, FASTElement } from '@microsoft/fast-element';
import { TabButtonsTemplate as template } from './tab-buttons.template';
import { TabButtonsStyles as styles } from './tab-buttons.styles';

const name = 'tab-buttons';

@customElement({
  name,
  template,
  styles,
})
export class TabButtons extends FASTElement {}
